import React, { useEffect, useState, useRef } from "react";
import ToolManagmentCard from "../../../../../common/element/Card/ToolManagmnetCard";
import ThreeDotBouncingLoader from "../../../../../common/element/ButtonLoader/ThreeDotBouncingLoder";
import { getCompanyProspectGeneratedUrlAPI } from "../../../../../redux/ProspectCompany/companyProspectApi";
import SweetAlertService from "../../../../../common/SweetAlert/SweetAlert";

const InfoField = ({ label, value }) => (
  <div className="text-start">
    <label className="block text-sm font-medium text-[#98A2B3] mb-1.5">{label}</label>
    <p className="text-[16px] font-medium text-[#101828]">{value || "—"}</p>
  </div>
);

const SectionLoader = () => (
  <div className="flex justify-center items-center py-10">
    <ThreeDotBouncingLoader />
  </div>
);

// Function to get file icon
const getFileIcon = (url) => {
  const ext = url?.toLowerCase() || '';

  const isImage = ['.png', '.jpg', '.jpeg', '.gif'].some(e => ext.includes(e));
  const isPdf = ext.includes('.pdf');

  if (isImage) {
    return (
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M9.46602 12.666H3.28693C2.88305 12.666 2.68111 12.666 2.5876 12.5862C2.50647 12.5169 2.46341 12.4129 2.47178 12.3065C2.48143 12.1839 2.62422 12.0411 2.90981 11.7556L8.57844 6.08693C8.84244 5.82292 8.97445 5.69091 9.12667 5.64145C9.26057 5.59795 9.4048 5.59795 9.53869 5.64145C9.69091 5.69091 9.82292 5.82292 10.0869 6.08693L12.666 8.66602V9.46602M9.46602 12.666C10.5861 12.666 11.1462 12.666 11.574 12.448C11.9503 12.2563 12.2563 11.9503 12.448 11.574C12.666 11.1462 12.666 10.5861 12.666 9.46602M9.46602 12.666H3.86602C2.74591 12.666 2.18586 12.666 1.75803 12.448C1.38171 12.2563 1.07575 11.9503 0.884003 11.574C0.666016 11.1462 0.666016 10.5861 0.666016 9.46602V3.86602C0.666016 2.74591 0.666016 2.18586 0.884003 1.75803C1.07575 1.38171 1.38171 1.07575 1.75803 0.884003C2.18586 0.666016 2.74591 0.666016 3.86602 0.666016H9.46602C10.5861 0.666016 11.1462 0.666016 11.574 0.884003C11.9503 1.07575 12.2563 1.38171 12.448 1.75803C12.666 2.18586 12.666 2.74591 12.666 3.86602V9.46602M5.66602 4.33268C5.66602 5.06906 5.06906 5.66602 4.33268 5.66602C3.5963 5.66602 2.99935 5.06906 2.99935 4.33268C2.99935 3.5963 3.5963 2.99935 4.33268 2.99935C5.06906 2.99935 5.66602 3.5963 5.66602 4.33268Z" stroke="white" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  if (isPdf) {
    return (
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.6424 10.2861C11.4593 10.34 11.1905 10.3461 10.9023 10.3044C10.593 10.2596 10.2775 10.1652 9.96737 10.0261C10.5204 9.9458 10.9494 9.97055 11.3163 10.1003C11.4032 10.1311 11.546 10.2133 11.6424 10.2861ZM8.55703 9.77971C8.53453 9.78582 8.51237 9.7916 8.49032 9.79771C8.34152 9.83814 8.19675 9.87759 8.05723 9.91269L7.8691 9.96031C7.49068 10.0559 7.10376 10.1536 6.72161 10.2698C6.86684 9.92023 7.00177 9.56675 7.13388 9.22115C7.2317 8.96532 7.33159 8.70399 7.43489 8.44602C7.4873 8.53242 7.54199 8.61886 7.5989 8.70552C7.85817 9.09972 8.18409 9.46419 8.55703 9.77971ZM7.59443 5.83722C7.61896 6.26863 7.52572 6.68364 7.38895 7.08177C7.22047 6.58947 7.14196 6.04584 7.35259 5.60694C7.40661 5.49444 7.45086 5.43429 7.47956 5.4029C7.52388 5.47122 7.58218 5.62407 7.59443 5.83722ZM5.6188 11.302C5.52414 11.4711 5.42752 11.6293 5.32849 11.7788C5.0895 12.1383 4.69864 12.5233 4.49785 12.5233C4.47809 12.5233 4.45418 12.5201 4.41924 12.4833C4.39675 12.4597 4.39314 12.4429 4.39423 12.4198C4.401 12.2876 4.57645 12.0522 4.83062 11.8339C5.06131 11.6359 5.32206 11.4598 5.6188 11.302ZM12.2817 10.3048C12.2511 9.86446 11.5085 9.58197 11.5012 9.57935C11.2142 9.47776 10.9024 9.42841 10.548 9.42841C10.1686 9.42841 9.7596 9.4832 9.23433 9.60571C8.76694 9.27496 8.3632 8.86089 8.06155 8.40249C7.92834 8.19995 7.80859 7.99779 7.7042 7.80031C7.95904 7.19203 8.18852 6.53799 8.14682 5.80546C8.1132 5.2181 7.84788 4.82356 7.48707 4.82356C7.23955 4.82356 7.02645 5.00656 6.85316 5.36799C6.54404 6.01201 6.62529 6.83607 7.09455 7.8194C6.92555 8.21566 6.76853 8.62648 6.61654 9.02416C6.42744 9.51867 6.23259 10.0289 6.01298 10.5142C5.39712 10.7575 4.89118 11.0525 4.46953 11.4146C4.1933 11.6515 3.8603 12.0135 3.84129 12.3915C3.83201 12.5695 3.89316 12.7328 4.0174 12.8636C4.1494 13.0024 4.31523 13.0756 4.49758 13.0758C5.09982 13.0758 5.67944 12.2498 5.7894 12.0841C6.01069 11.7511 6.21783 11.3797 6.42079 10.9512C6.93197 10.7668 7.47674 10.6291 8.00475 10.4961L8.19385 10.4481C8.336 10.412 8.48374 10.3721 8.63528 10.3307C8.79564 10.2875 8.96063 10.2426 9.12832 10.1999C9.67049 10.5442 10.2535 10.7687 10.8222 10.8511C11.3011 10.9206 11.7265 10.8803 12.0144 10.7304C12.2735 10.5957 12.2878 10.3878 12.2817 10.3048ZM13.4481 14.0911C13.4481 14.8975 12.7361 14.9472 12.5925 14.9488H3.40675C2.60188 14.9488 2.55341 14.2332 2.55188 14.0911L2.55177 1.90866C2.55177 1.10146 3.26505 1.05252 3.40664 1.0509H9.61178L9.61508 1.05418V3.47149C9.61508 3.95661 9.90888 4.87509 11.0215 4.87509H13.4274L13.448 4.89567L13.4481 14.0911ZM12.8777 4.3241H11.0219C10.2173 4.3241 10.1686 3.61238 10.1675 3.47156V1.6074L12.8777 4.3241ZM14 14.0911V4.66839L10.1675 0.826633V0.808759H10.1492L9.84138 0.5H3.40677C2.92017 0.5 2 0.794501 2 1.90892V14.0913C2 14.5785 2.29412 15.5 3.40677 15.5H12.5933C13.0798 15.4999 14 15.2054 14 14.0911Z" fill="white" />
      </svg>
    );
  }

  return (
    <svg width="14" height="16" viewBox="0 0 14 16" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.15783 0C4.96241 0 4.77499 0.0766254 4.63681 0.213011L0.215811 4.57665C0.0776328 4.71304 0 4.89802 0 5.09091V13.8182C0 15.0232 0.989677 16 2.2105 16H11.0525C12.2733 16 13.263 15.0232 13.263 13.8182V2.18182C13.263 0.976836 12.2733 0 11.0525 0H5.15783Z" fill="white" />
    </svg>
  );
};

const getFileName = (url) => {
  return url.split('/').pop();
};

const Overview = ({ companyDetail, isLoading, addressLine1, addressLine2 }) => {
  const [generatedUrl, setGeneratedUrl] = useState(null);
  const [fetchingUrl, setFetchingUrl] = useState(false);
  const [copyingUrl, setCopyingUrl] = useState(false);
  const [showCopied, setShowCopied] = useState(false);
  const copiedTimeoutRef = useRef(null);

  const handleCopyUrl = async () => {
    if (!generatedUrl) return;
    try {
      setCopyingUrl(true);
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(generatedUrl);
      } else {
        // fallback for older browsers
        const textarea = document.createElement('textarea');
        textarea.value = generatedUrl;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'absolute';
        textarea.style.left = '-9999px';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
      }

  // show small inline toast instead of modal
  setShowCopied(true);
  if (copiedTimeoutRef.current) clearTimeout(copiedTimeoutRef.current);
  copiedTimeoutRef.current = setTimeout(() => setShowCopied(false), 5000);
    } catch (err) {
      SweetAlertService.showError({
        title: 'Error!',
        message: err?.message || 'Failed to copy link. Please try manually.',
      });
    } finally {
      setCopyingUrl(false);
    }
  };

  useEffect(() => {
    return () => {
      if (copiedTimeoutRef.current) clearTimeout(copiedTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    const fetchUrl = async () => {
      if (!companyDetail?.company_id) return;
      try {
        setFetchingUrl(true);
        const response = await getCompanyProspectGeneratedUrlAPI(companyDetail.company_id);
        // response may come as { data: { generatedUrl: '...' } } or directly { generatedUrl: '...' } or a string
        const data = response?.data || response;
        const url = data?.generatedUrl || data?.url || (typeof data === "string" ? data : "");
        setGeneratedUrl(url || null);
      } catch (error) {
        setGeneratedUrl(null);
        SweetAlertService.showError({
          title: "Error!",
          message: error?.response?.data?.message || error?.message || "Failed to fetch generated URL.",
        });
      } finally {
        setFetchingUrl(false);
      }
    };

    fetchUrl();
  }, [companyDetail?.company_id]);


  const companyFields = [
    { label: "Company Name", value: companyDetail?.company_name },
    { label: "Contact Person Name", value: companyDetail?.contact_person },
    { label: "Company Email", value: companyDetail?.contact_email },
    { label: "Company Work phone number", value: companyDetail?.work_phone },
    { label: "Company Phone number", value: companyDetail?.contact_phone },
    { label: "Landline", value: companyDetail?.phone_landline },
    { label: "Country", value: companyDetail?.country?.country_name },
    { label: "State", value: companyDetail?.state?.state_name },
    { label: "City", value: companyDetail?.city?.city_name },
    { label: "Address 1", value: addressLine1 || companyDetail?.address },
    { label: "Address 2", value: addressLine2 },
    { label: "Pincode", value: companyDetail?.pincode },
  ];

  return (
    <div className="grid grid-cols-3 gap-6">
      {/* Left Section – Company Information */}
      <div className="col-span-2">
        <ToolManagmentCard>
          <div className="flex justify-between items-center pb-4 border-b border-gray-200">
            <h3 className="font-lato font-medium text-[16px] leading-[150%] text-[#101828]">Company information</h3>
          </div>

          <div className="py-6">
            {isLoading ? (
              <SectionLoader />
            ) : (
              <div className="grid grid-cols-2 gap-x-6 gap-y-5 text-start">
                {companyFields.map((item, index) => (
                  <div key={index}>
                    <p className="font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">{item.label}</p>
                    <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828]">
                      {item.value || "—"}
                    </p>
                  </div>
                ))}

                {/* Generated link from API */}
                <div className="col-span-2">
                  <p className="font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Generated Link</p>
                  {fetchingUrl ? (
                    <div className="py-2"><ThreeDotBouncingLoader /></div>
                  ) : generatedUrl ? (
                    <div className="flex items-start gap-3">
                      <a
                        href={generatedUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] hover:text-orange-600 break-all flex-1"
                      >
                        {generatedUrl}
                      </a>

                      <button
                        type="button"
                        onClick={handleCopyUrl}
                        disabled={copyingUrl}
                        className="w-8 h-8 rounded-md flex items-center justify-center border border-[#E4E7EC] bg-white hover:bg-gray-50"
                        aria-label="Copy generated link"
                        title="Copy link"
                      >
                        {copyingUrl ? (
                          <div className="w-5 h-5 flex items-center justify-center">
                            <ThreeDotBouncingLoader />
                          </div>
                        ) : (
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.5572 2.08455C12.8959 0.740719 14.9577 0.631775 16.1625 1.84122C17.3673 3.05068 17.2588 5.12051 15.9201 6.46434L13.9811 8.41094M7.43673 10.6009C6.23196 9.39142 6.34048 7.32156 7.67913 5.97772L9.39962 4.25056" stroke="#475467" stroke-width="2" stroke-linecap="round" />
                            <path d="M10.5629 7.40088C11.7677 8.61032 11.6592 10.6802 10.3205 12.024L8.38147 13.9706L6.44241 15.9172C5.10377 17.261 3.0419 17.3699 1.83712 16.1605C0.632343 14.951 0.740872 12.8812 2.07952 11.5374L4.0186 9.59072" stroke="#475467" stroke-width="2" stroke-linecap="round" />
                          </svg>

                        )}
                      </button>
                    </div>
                  ) : (
                    <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828]">—</p>
                  )}
                  {/* Inline transient copied toast */}
                  {showCopied && (
                    <div className="mt-2 inline-block px-3 py-1 rounded-md bg-black bg-opacity-80 text-white text-sm">
                      Copied!
                    </div>
                  )}
                </div>

                {/* Social icons */}
                {companyDetail?.social_links && Array.isArray(companyDetail.social_links) && companyDetail.social_links.length > 0 && (
                  <div className="col-span-2 mt-2">
                    <p className="font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">Social Media links</p>
                    <div className="flex items-center gap-3">
                      {companyDetail.social_links.map((link, idx) => {
                        if (!link) return null;
                        let provider = '';
                        try {
                          const url = new URL(link);
                          const host = url.hostname.toLowerCase();
                          if (host.includes('facebook.com')) provider = 'facebook';
                          else if (host.includes('instagram.com')) provider = 'instagram';
                          else if (host.includes('linkedin.com')) provider = 'linkedin';
                          else if (host.includes('youtube.com') || host.includes('youtu.be')) provider = 'youtube';
                          else if (host.includes('twitter.com') || host.includes('x.com')) provider = 'twitter';
                          else if (host.includes('github.com')) provider = 'github';
                          else provider = 'link';
                        } catch (e) {
                          provider = 'link';
                        }

                        const Icon = ({ name }) => {
                          switch (name) {
                            case 'facebook':
                              return (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10 0C4.4772 0 0 4.4772 0 10C0 14.6896 3.2288 18.6248 7.5844 19.7056V13.056H5.5224V10H7.5844V8.6832C7.5844 5.2796 9.1248 3.702 12.4664 3.702C13.1 3.702 14.1932 3.8264 14.6404 3.9504V6.7204C14.4044 6.6956 13.9944 6.6832 13.4852 6.6832C11.8456 6.6832 11.212 7.3044 11.212 8.9192V10H14.4784L13.9172 13.056H11.212V19.9268C16.1636 19.3288 20.0004 15.1128 20.0004 10C20 4.4772 15.5228 0 10 0Z" fill="#101828" />
                                </svg>
                              );
                            case 'instagram':
                              return (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path fillRule="evenodd" clipRule="evenodd" d="M10 1.80078C12.6719 1.80078 12.9883 1.8125 14.0391 1.85937C15.0156 1.90234 15.543 2.06641 15.8945 2.20313C16.3594 2.38281 16.6953 2.60156 17.043 2.94922C17.3945 3.30078 17.6094 3.63281 17.7891 4.09766C17.9258 4.44922 18.0898 4.98047 18.1328 5.95313C18.1797 7.00781 18.1914 7.32422 18.1914 9.99219C18.1914 12.6641 18.1797 12.9805 18.1328 14.0313C18.0898 15.0078 17.9258 15.5352 17.7891 15.8867C17.6094 16.3516 17.3906 16.6875 17.043 17.0352C16.6914 17.3867 16.3594 17.6016 15.8945 17.7813C15.543 17.918 15.0117 18.082 14.0391 18.125C12.9844 18.1719 12.668 18.1836 10 18.1836C7.32813 18.1836 7.01172 18.1719 5.96094 18.125C4.98438 18.082 4.45703 17.918 4.10547 17.7813C3.64063 17.6016 3.30469 17.3828 2.95703 17.0352C2.60547 16.6836 2.39063 16.3516 2.21094 15.8867C2.07422 15.5352 1.91016 15.0039 1.86719 14.0313C1.82031 12.9766 1.80859 12.6602 1.80859 9.99219C1.80859 7.32031 1.82031 7.00391 1.86719 5.95313C1.91016 4.97656 2.07422 4.44922 2.21094 4.09766C2.39063 3.63281 2.60938 3.29688 2.95703 2.94922C3.30859 2.59766 3.64063 2.38281 4.10547 2.20313C4.45703 2.06641 4.98828 1.90234 5.96094 1.85937C7.01172 1.8125 7.32813 1.80078 10 1.80078ZM10 0C7.28516 0 6.94531 0.0117187 5.87891 0.0585938C4.81641 0.105469 4.08594 0.277344 3.45313 0.523437C2.79297 0.78125 2.23438 1.12109 1.67969 1.67969C1.12109 2.23438 0.78125 2.79297 0.523438 3.44922C0.277344 4.08594 0.105469 4.8125 0.0585938 5.875C0.0117188 6.94531 0 7.28516 0 10C0 12.7148 0.0117188 13.0547 0.0585938 14.1211C0.105469 15.1836 0.277344 15.9141 0.523438 16.5469C0.78125 17.207 1.12109 17.7656 1.67969 18.3203C2.23438 18.875 2.79297 19.2188 3.44922 19.4727C4.08594 19.7188 4.8125 19.8906 5.875 19.9375C6.94141 19.9844 7.28125 19.9961 9.99609 19.9961C12.7109 19.9961 13.0508 19.9844 14.1172 19.9375C15.1797 19.8906 15.9102 19.7188 16.543 19.4727C17.1992 19.2188 17.7578 18.875 18.3125 18.3203C18.8672 17.7656 19.2109 17.207 19.4648 16.5508C19.7109 15.9141 19.8828 15.1875 19.9297 14.125C19.9766 13.0586 19.9883 12.7188 19.9883 10.0039C19.9883 7.28906 19.9766 6.94922 19.9297 5.88281C19.8828 4.82031 19.7109 4.08984 19.4648 3.45703C19.2188 2.79297 18.8789 2.23438 18.3203 1.67969C17.7656 1.125 17.207 0.78125 16.5508 0.527344C15.9141 0.28125 15.1875 0.109375 14.125 0.0625C13.0547 0.0117188 12.7148 0 10 0Z" fill="#101828" />
                                  <path d="M10 4.86328C7.16406 4.86328 4.86328 7.16406 4.86328 10C4.86328 12.8359 7.16406 15.1367 10 15.1367C12.8359 15.1367 15.1367 12.8359 15.1367 10C15.1367 7.16406 12.8359 4.86328 10 4.86328ZM10 13.332C8.16016 13.332 6.66797 11.8398 6.66797 10C6.66797 8.16016 8.16016 6.66797 10 6.66797C11.8398 6.66797 13.332 8.16016 13.332 10C13.332 11.8398 11.8398 13.332 10 13.332Z" fill="#101828" />
                                  <path d="M16.5391 4.66016C16.5391 5.32422 16 5.85938 15.3398 5.85938C14.6758 5.85938 14.1406 5.32031 14.1406 4.66016C14.1406 3.99609 14.6797 3.46094 15.3398 3.46094C16 3.46094 16.5391 4 16.5391 4.66016Z" fill="#101828" />
                                </svg>
                              );
                            case 'linkedin':
                              return (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M18.5195 0H1.47656C0.660156 0 0 0.644531 0 1.44141V18.5547C0 19.3516 0.660156 20 1.47656 20H18.5195C19.3359 20 20 19.3516 20 18.5586V1.44141C20 0.644531 19.3359 0 18.5195 0ZM5.93359 17.043H2.96484V7.49609H5.93359V17.043ZM4.44922 6.19531C3.49609 6.19531 2.72656 5.42578 2.72656 4.47656C2.72656 3.52734 3.49609 2.75781 4.44922 2.75781C5.39844 2.75781 6.16797 3.52734 6.16797 4.47656C6.16797 5.42188 5.39844 6.19531 4.44922 6.19531ZM17.043 17.043H14.0781V12.4023C14.0781 11.2969 14.0586 9.87109 12.5352 9.87109C10.9922 9.87109 10.7578 11.0781 10.7578 12.3242V17.043H7.79688V7.49609H10.6406V8.80078H10.6797C11.0742 8.05078 12.043 7.25781 13.4844 7.25781C16.4883 7.25781 17.043 9.23438 17.043 11.8047V17.043Z" fill="#101828" />
                                </svg>
                              );
                            case 'youtube':
                              return (
                                <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.8008 3.03516C19.8008 3.03516 19.6055 1.65625 19.0039 1.05078C18.2422 0.253906 17.3906 0.25 17 0.203125C14.2031 -1.11759e-07 10.0039 0 10.0039 0H9.99609C9.99609 0 5.79687 -1.11759e-07 3 0.203125C2.60938 0.25 1.75781 0.253906 0.996094 1.05078C0.394531 1.65625 0.203125 3.03516 0.203125 3.03516C0.203125 3.03516 0 4.65625 0 6.27344V7.78906C0 9.40625 0.199219 11.0273 0.199219 11.0273C0.199219 11.0273 0.394531 12.4063 0.992187 13.0117C1.75391 13.8086 2.75391 13.7813 3.19922 13.8672C4.80078 14.0195 10 14.0664 10 14.0664C10 14.0664 14.2031 14.0586 17 13.8594C17.3906 13.8125 18.2422 13.8086 19.0039 13.0117C19.6055 12.4063 19.8008 11.0273 19.8008 11.0273C19.8008 11.0273 20 9.41016 20 7.78906V6.27344C20 4.65625 19.8008 3.03516 19.8008 3.03516ZM7.93359 9.62891V4.00781L13.3359 6.82812L7.93359 9.62891Z" fill="#101828" />
                                </svg>
                              );
                            case 'twitter':
                              return (
                                <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.4386 0H17.2498L11.1081 7.01958L18.3333 16.5716H12.676L8.24503 10.7784L3.17496 16.5716H0.362027L6.9312 9.06341L0 0H5.80092L9.80616 5.29528L14.4386 0ZM13.4519 14.889H15.0097L4.9545 1.59428H3.28288L13.4519 14.889Z" fill="#101828" />
                                </svg>
                              );
                            case 'github':
                              return (
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 .5C5.65.5.5 5.65.5 12c0 5.08 3.29 9.38 7.86 10.9.58.1.79-.25.79-.56v-2.02c-3.2.69-3.87-1.41-3.87-1.41-.52-1.33-1.27-1.69-1.27-1.69-1.04-.71.08-.7.08-.7 1.15.08 1.76 1.18 1.76 1.18 1.02 1.75 2.68 1.25 3.33.96.1-.75.4-1.25.72-1.54-2.55-.29-5.24-1.28-5.24-5.68 0-1.25.45-2.27 1.18-3.07-.12-.29-.51-1.45.11-3.02 0 0 .96-.31 3.14 1.17a10.9 10.9 0 0 1 5.72 0c2.18-1.48 3.14-1.17 3.14-1.17.62 1.57.23 2.73.11 3.02.73.8 1.18 1.82 1.18 3.07 0 4.4-2.7 5.39-5.27 5.67.41.36.77 1.08.77 2.18v3.24c0 .31.21.67.8.56A11.51 11.51 0 0 0 23.5 12C23.5 5.65 18.35.5 12 .5z" fill="#181717" /></svg>
                              );
                            default:
                              return (
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M19.8079 8.14476H10.213V11.9894H15.7263C15.6377 12.5336 15.4387 13.0688 15.1472 13.5569C14.8133 14.1161 14.4006 14.5418 13.9775 14.866C12.7101 15.8372 11.2325 16.0358 10.2063 16.0358C7.61409 16.0358 5.39919 14.3604 4.54176 12.0838C4.50716 12.0012 4.48418 11.9159 4.4562 11.8315C4.26673 11.2521 4.1632 10.6384 4.1632 10.0006C4.1632 9.33685 4.27531 8.70145 4.47972 8.10134C5.28599 5.73451 7.55082 3.96672 10.2082 3.96672C10.7427 3.96672 11.2574 4.03034 11.7455 4.15724C12.861 4.44725 13.6501 5.01843 14.1336 5.47023L17.0511 2.61313C15.2764 0.985972 12.9629 2.46015e-09 10.2033 2.46015e-09C7.99721 -4.74827e-05 5.96042 0.687318 4.29133 1.84899C2.93776 2.79107 1.82764 4.0524 1.07844 5.5173C0.381576 6.87555 0 8.38075 0 9.99913C0 11.6176 0.382159 13.1384 1.07902 14.4841V14.4932C1.81508 15.9218 2.89146 17.1519 4.19967 18.0897C5.34254 18.9089 7.39181 20 10.2033 20C11.8202 20 13.2531 19.7085 14.5169 19.1622C15.4285 18.7681 16.2363 18.2541 16.9676 17.5935C17.9339 16.7206 18.6906 15.6409 19.2072 14.3987C19.7237 13.1565 20 11.7518 20 10.2289C20 9.51963 19.9288 8.79934 19.8079 8.14469V8.14476Z" fill="#101828" />
                                </svg>
                              );
                          }
                        };

                        return (
                          <a key={idx} href={link} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-white border border-gray-100 shadow-sm hover:opacity-90">
                            <span className="sr-only">Open {provider} link</span>
                            <Icon name={provider} />
                          </a>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </ToolManagmentCard>
      </div>

      {/* Right Section – HR + Notes + Social Links */}
      <div className="flex flex-col gap-6">
        {/* HR Information */}
        <ToolManagmentCard>
          <div className="flex justify-between items-center pb-4 border-b border-gray-200">
            <h3 className="font-lato font-medium text-[16px] leading-[150%] text-[#101828]">HR information</h3>
          </div>

          <div className="py-6">
            {isLoading ? (
              <SectionLoader />
            ) : (
              <div className="grid grid-cols-2 gap-x-6 gap-y-5 text-start">
                <div className="col-span-2">
                  <p className="font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">HR Name</p>
                  <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828]">
                    {companyDetail?.hr?.first_name}{" "}
                    {companyDetail?.hr?.last_name}
                  </p>
                </div>

                <div>
                  <p className="font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">HR Email</p>
                  <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] break-all">{companyDetail?.hr?.email || "—"}</p>
                </div>

                <div>
                  <p className="font-lato font-medium text-[14px] leading-[150%] text-[#98A2B3]">HR Number</p>
                  <p className="font-lato font-medium text-[16px] leading-[150%] text-[#101828] break-all">{companyDetail?.hr?.mobile_number || "—"}</p>
                </div>
              </div>
            )}
          </div>
        </ToolManagmentCard>

        {/* Notes & Documents */}
        <ToolManagmentCard>
          <div className="flex justify-between items-center pb-4 border-b border-gray-200">
            <h3 className="font-lato font-medium text-[16px] leading-[150%] text-[#101828]">Notes & Documents</h3>
          </div>
          {/* Scrollable container: max height for ~2 items */}
          <div className="py-5 space-y-4 max-h-[300px] overflow-y-auto pr-2 custom-scrollbar">
            {isLoading ? (
              <SectionLoader />
            ) : (
              <>
                {companyDetail?.notesAndDocuments?.map((item, index) => (
                  <React.Fragment key={index}>
                    {item.documents && item.documents.length > 0 ? (
                      item.documents.map((docUrl, docIndex) => (
                        <div key={`${index}-${docIndex}`} className="p-4 bg-white border border-[#E4E7EC] rounded-xl text-start">
                          <div className="flex items-center gap-4">
                            <div className="relative w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0">
                              <div className="absolute inset-0 rounded-full bg-[#FF9800] opacity-20" />
                              <div className="relative w-8 h-8 rounded-full bg-[#F59E0B] flex items-center justify-center">
                                {getFileIcon(docUrl)}
                              </div>
                            </div>
                            <div className="flex-1">
                              <a
                                href={docUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="font-lato font-medium text-[15px] leading-[150%] tracking-normal text-[#475467] hover:text-orange-600 block break-all"
                              >
                                {getFileName(docUrl)}
                              </a>
                            </div>
                          </div>
                          {item.notes && (
                            <>
                              <hr className="my-3 border-[#EAECF0]" />
                              <p className="font-lato font-medium text-[14px] leading-[150%] tracking-normal text-[#101828]">
                                {item.notes}
                              </p>
                            </>
                          )}
                        </div>
                      ))
                    ) : (
                      /* Show note even if there's no document */
                      item.notes && (
                        <div className="p-4 bg-white border border-[#E4E7EC] rounded-xl text-start">
                          <p className="font-lato font-medium text-[14px] leading-[150%] tracking-normal text-[#101828]">
                            {item.notes}
                          </p>
                        </div>
                      )
                    )}
                  </React.Fragment>
                ))}

                {(!companyDetail?.notesAndDocuments || companyDetail.notesAndDocuments.length === 0) && (
                  <p className="text-gray-500 text-center py-8">No notes or documents available</p>
                )}
              </>
            )}
          </div>
        </ToolManagmentCard>

      </div>
    </div>
  );
};

export default Overview;
